export default [
  {
    path: '/admin/borrowing-spare-parts',
    name: 'borrowing-spare-part',
    meta: { requiresAuth: true },
    component: () => import('@/pages/wholesale/borrowing-spare-part/index.vue')
  },
  {
    path: '/admin/borrowing-spare-parts/create',
    name: 'borrowing-spare-part-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/wholesale/borrowing-spare-part/create.vue')
  },
  {
    path: '/admin/borrowing-spare-parts/:id/edit',
    name: 'borrowing-spare-part-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/wholesale/borrowing-spare-part/edit.vue')
  },
  {
    path: '/admin/borrowing-spare-parts/generate-invoices',
    name: 'borrowing-spare-part-generate',
    meta: { requiresAuth: true },
    component: () => import('@/pages/wholesale/borrowing-spare-part/generate-invoice.vue')
  }
]
